import { render, staticRenderFns } from "./CultureViImageRegisterInfo.vue?vue&type=template&id=482eeff0&scoped=true&"
import script from "./CultureViImageRegisterInfo.vue?vue&type=script&lang=js&"
export * from "./CultureViImageRegisterInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482eeff0",
  null
  
)

export default component.exports